import api from '@/api'
import Vue from 'vue';
import permissions from '@/api/permissions'
import _ from 'lodash'

export default {
  actions: {
    async postLotComment({ dispatch }, { lotId, file, text }) {
      let error;

      try {
        const data = new FormData();
        data.append('value', JSON.stringify({ text }));

        if (file) {
          data.append('file', file);
        }

        const response = await api.post(`/comments/${lotId}`, data);
        const { status, result, errorCode } = response.data;

        if (status === 200) {
          dispatch('handlePublicLot', result);
        }
        else {
          throw new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async updateLotComment({ dispatch }, { lotId, commentId, file, text }) {
      let error;

      try {
        const json = { text };

        const data = new FormData();

        if (file === undefined) {
          json.deleteFile = true
        }

        data.append('value', JSON.stringify(json));

        if (file instanceof File) {
          data.append('file', file);
        }

        const response = await api.post(`/comments/${lotId}/${commentId}/updateask`, data);
        const { status, result, errorCode } = response.data;

        if (status === 200) {
          dispatch('handlePublicLot', result);
        }
        else {
          throw new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async deleteLotQuestion({ dispatch }, { lotId, questionId }) {
      let error;

      try {
        const data = new FormData();
        data.append('value', text);

        if (file) {
          data.append('file', file);
        }

        const response = await api.delete(`/comments/${lotId}/${questionId}/deleteask`);
        const { status, result, errorCode } = response.data;

        if (status === 200) {
          dispatch('handlePublicLot', result);
        }
        else {
          throw new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },
  }
}
